<template>
    <div class="NewQCStep3">
        <!--List criteria-->
        <div class="p-12 content-tab fci-scrollbar">
            <table class="criteria-table">
                <thead>
                <tr>
                    <th scope="col" class="text-left">{{ this.$f.tc('type') }}</th>
                    <th scope="col" class="text-left">{{ this.$f.tc('name') }}</th>
                    <th scope="col" class="text-left">{{ this.$f.tc('description') }}</th>
                    <th scope="col" class="text-left">{{ this.$f.tc('default') }}</th>
                    <th scope="col">{{ this.$f.tc('monitor') }}</th>
                    <th scope="col">{{ this.$f.tc('required') }}</th>
                    <th></th>
                </tr>
                </thead>

                <!--Draggable criteria-->
                <draggable v-model="dataTable" tag="tbody"
                           :move="onMoveCallback"
                           :clone="onCloneCallback"
                           @end="onDropCallback">
                    <tr v-for="item in dataTable" :key="item.name">
                        <td>{{ item.type }}</td>
                        <td>
                            <v-textarea
                                v-if="item.id === editModel.id"
                                v-model="editModel.name"
                                class="textarea-custom"
                                :rows="2"
                                :rules="formRules.required"
                            ></v-textarea>
                            <v-textarea
                                v-else
                                v-model="item.name"
                                :rows="2"
                                class="textarea-custom"
                                readonly
                            ></v-textarea>
                        </td>
                        <td>
                            <v-textarea
                                v-if="item.id === editModel.id"
                                v-model="editModel.description"
                                class="textarea-custom"
                                :rows="2"
                            ></v-textarea>
                            <v-textarea
                                v-else
                                v-model="item.description"
                                :rows="2"
                                class="textarea-custom"
                                readonly
                            ></v-textarea>
                        </td>
                        <td>
                            <v-select
                                v-if="item.id === editModel.id && item.type !== 'TEXT'"
                                :items="JSON.parse(item.config)"
                                :return-object="false"
                                v-model="editModel.default_value"
                                item-value="value"
                                item-text="value"
                                @click:clear="setDefaultValue(editModel, 'default_value', '')"
                                clearable
                                class="input-custom"
                            ></v-select>
                            <v-textarea
                                v-if="item.id === editModel.id && item.type === 'TEXT'"
                                v-model="editModel.default_value"
                                :rows="2"
                                class="textarea-custom"
                            ></v-textarea>
                            <v-textarea
                                v-if="item.id !== editModel.id"
                                v-model="item.default_value"
                                :rows="2"
                                class="textarea-custom"
                                readonly
                            ></v-textarea>
                        </td>
                        <td>
                            <v-checkbox
                                v-if="item.id === editModel.id"
                                v-model="editModel['is_monitor']"
                                color="#0052CC"
                                :hide-details="true"
                                style="margin-left: 27px"
                            ></v-checkbox>
                            <v-checkbox
                                v-else
                                v-model="item['is_monitor']"
                                :hide-details="true"
                                style="margin-left: 27px"
                                disabled
                            ></v-checkbox>
                        </td>
                        <td>
                            <v-checkbox
                                v-if="item.id === editModel.id"
                                v-model="editModel['is_required']"
                                color="#0052CC"
                                :hide-details="true"
                                style="margin-left: 27px"
                            ></v-checkbox>
                            <v-checkbox
                                v-else
                                v-model="item['is_required']"
                                :hide-details="true"
                                style="margin-left: 27px"
                                disabled
                            ></v-checkbox>
                        </td>
                        <td>
                            <div v-if="item.id === editModel.id" class="centerXY">
                                <v-btn icon small @click="closeEdit"
                                       style="margin: 0!important">
                                    <img src="/img/close.svg" alt="icon-config"
                                         style="transform: scale(1.3)">
                                </v-btn>
                                <v-btn icon small @click="saveEdit(item)"
                                       style="margin: 0!important">
                                    <img src="/img/save-member-2.svg" alt="icon-config"
                                         style="transform: scale(0.9)">
                                </v-btn>
                            </div>
                            <div v-else class="centerXY">
                                <div class="btn-icon mr-1" v-if="item.type === 'ENUM'"
                                     @click="openCriteriaConfig(item)">
                                    <img src="/img/config.svg" alt="icon-config" style="transform: scale(0.9)">
                                </div>
                                <div class="btn-icon mr-1" @click="editCriteriaItem(item)">
                                    <img src="/img/edit-2.svg" alt="icon-edit" style="transform: scale(0.9)">
                                </div>
                                <div class="btn-icon" @click="deleteCriteriaItem(item)">
                                    <img src="/img/delete-new.svg" alt="icon-delete" style="transform: scale(0.9)">
                                </div>
                            </div>
                        </td>
                    </tr>
                </draggable>
            </table>

            <!--Add new criteria-->
            <div class="btn-custom-normal" @click="handleClickAddNew" style="border-top: none;" v-show="!isShowAddItem">
                <img src="/img/add-member.svg" alt="icon-add" style="padding-right: 6px">
                {{ $f.tc('addNew') }}
            </div>
            <v-form v-show="isShowAddItem" class="table-add-member" v-model="formValid"
                    ref="form">
                <div class="item-new-member centerXY">
                    <v-select
                        v-model="model.type"
                        :rules="formRules.required"
                        :items="typeOptions"
                        item-value="value"
                        item-text="name"
                        class="input-custom"
                    ></v-select>
                </div>
                <div class="item-new-member centerXY">
                    <v-textarea v-model="model.name" class="textarea-custom" :rows="2" :rules="formRules.required"
                                ref="NewCriteriaName"></v-textarea>
                </div>
                <div class="item-new-member">
                    <v-textarea v-model="model.description" class="textarea-custom" :rows="2"></v-textarea>
                </div>
                <div class="item-new-member">
                    <v-textarea v-if="model.type==='TEXT'" v-model="model.default_value" class="textarea-custom"
                                :rows="2"></v-textarea>
                    <v-select
                        v-else
                        :items="model.type==='BOOL'?['correct','wrong']:[]"
                        v-model="model.default_value"
                        clearable
                        class="input-custom"
                    ></v-select>
                </div>
                <div class="item-new-member">
                    <v-checkbox
                        v-model="model.monitor"
                        color="#0052CC"
                        :hide-details="true"
                        style="margin-left: 37px"
                    ></v-checkbox>
                </div>
                <div class="item-new-member">
                    <v-checkbox
                        v-model="model.required"
                        color="#0052CC"
                        :hide-details="true"
                        style="margin-left: 37px"
                    ></v-checkbox>
                </div>

                <div class="item-new-member">
                    <div @click="cancelAddCriteria" class="btn-icon mr-6">
                        <img src="/img/close.svg" alt="icon-config" style="transform: scale(1.3)">
                    </div>
                    <div class="btn-icon" @click="submit">
                        <img src="/img/save-member-2.svg" alt="icon-save" style="transform: scale(0.9);">
                    </div>
                </div>
            </v-form>
        </div>

        <!--Footer-->
        <div class="dialog-footer justify-center" v-if="!hideFooter">
            <div class="btn-primary btn-back" @click="backStep">
                <img class="mr-12" src="/img/arrow-right.svg" alt="icon-back" style="transform: rotate(180deg)">
                {{ $f.tc('back') }}
            </div>
            <div class="btn-primary" @click="nextStep">
                {{ $f.tc('next') }}
                <img class="ml-12" src="/img/arrow-right.svg" alt="icon-next">
            </div>
        </div>
        <CriteriaConfigEditor ref="CriteriaConfigEditor" @isChangeEnumConfig="changeEnumConfig"></CriteriaConfigEditor>
    </div>
</template>

<script>
import FormMixin from '@/modules/fptai/mixins/FormMixin'
import RoleMixin from '@/modules/fptai/mixins/RoleMixin'
import { mapState } from 'vuex'
import QcCampaignService from '@/services/qc.campaign.service'
import CriteriaConfigEditor from '@/views/QualityControl/Dialog/CriteriaConfigEditor'
import draggable from 'vuedraggable'
import lodash from 'lodash'

const typeOptions = [
    { name: 'BOOL', value: 'BOOL' },
    { name: 'ENUM', value: 'ENUM' },
    { name: 'TEXT', value: 'TEXT' }
]

const defaultModel = {
    type: 'BOOL',
    name: '',
    description: '',
    monitor: false,
    data_input: [],
    required: true,
    default_value: '',
}

export default {
    name: 'NewQCStep3',
    components: { CriteriaConfigEditor, draggable },
    mixins: [
        FormMixin,
        RoleMixin
    ],
    props: {
        hideFooter: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            typeOptions,
            showConfirmOverlay: false,
            criteriaToDelete: false,
            criteriaToConfig: false,
            isShowAddItem: false,
            model: this.$utils.cloneObject(defaultModel),
            editModel: {},
            editModelIndex: -1,
            dragFrom: {},
            dragTo: {},
        }
    },
    computed: {
        ...mapState({
            isEdit: state => state.campaign.isEdit,
            qcCampaign: state => state.qccampaign.campaign,
        }),
        headers () {
            return [
                {
                    text: this.$f.tc('type'),
                    value: 'type'
                },
                {
                    text: this.$f.tc('name'),
                    value: 'name',
                    type: 'custom',
                    id: 'name'
                },
                {
                    text: this.$f.tc('description'),
                    value: 'description',
                    type: 'custom',
                    id: 'description'
                },
                {
                    text: this.$f.tc('default'),
                    value: 'default_value',
                    type: 'custom',
                    id: 'default_value'
                },
                {
                    text: this.$f.tc('monitor'),
                    value: 'is_monitor',
                    type: 'custom',
                    id: 'is_monitor'
                },
                {
                    text: this.$f.tc('required'),
                    value: 'is_required',
                    type: 'custom',
                    id: 'is_required'
                },

                {
                    text: '',
                    value: 'action',
                    sortable: false,
                    type: 'custom',
                    id: 'action'
                }
            ]
        },
        dataTable () {
            return this.qcCampaign ? this.qcCampaign['criteria'] : []
        }
    },
    mounted () {
        this.getCriteria()
    },
    methods: {
        getCriteria () {
            if (this.qcCampaign) {
                this.$appService.showLoading()
                QcCampaignService.CriteriaService.search(this.qcCampaign.id).then(result => {
                    this.$store.commit(this.$actionTypes.qccampaign.UPDATE_CRITERIA, result.data)
                    this.updateCriteria(result.data)
                    if (this.isShowAddItem) {
                        this.model = this.$utils.cloneObject(defaultModel)
                        this.isShowAddItem = false
                    }
                }).finally(this.$appService.hideLoading)
            }
        },
        submit (event) {
            if (event) {
                event.preventDefault()
            }

            if (this.formValid) {
                this.$appService.showLoading()
                if (!this.model.monitor) {
                    this.model.monitor = false
                }

                if (!this.model.required) {
                    this.model.required = false
                }
                QcCampaignService.CriteriaService.create(this.qcCampaign.id, {
                    data_input: this.model.data_input,
                    description: this.model.description,
                    is_monitor: this.model.monitor,
                    name: this.model.name,
                    type: this.model.type,
                    is_required: this.model.required,
                    default_value: this.model.default_value,
                }).then(() => {
                    this.getCriteria()
                }).finally(this.$appService.hideLoading)
            } else {
                this.$refs.form.validate()
            }
        },
        editCriteriaItem (item) {
            this.editModelIndex = this.dataTable.indexOf(item)
            this.editModel = Object.assign({}, item)
        },
        cancelAddCriteria () {
            this.isShowAddItem = false
            this.$refs.form.resetValidation()
            this.model = this.$utils.cloneObject(defaultModel)
        },
        deleteCriteriaItem (item) {
            let deleteMessage = this.$t('delete') + ' ' + this.$t('criteria') + ' ' + item.name
            const i18n = {
                action: this.$t('delete'),
                item: this.$t('criteria')
            }
            this.$appService.confirm(deleteMessage).then(
                confirm => {
                    if (confirm) {
                        this.$appService.showLoading()
                        QcCampaignService.CriteriaService.delete(this.qcCampaign.id, item.id).then(
                            result => {
                                this.$appService.toastSuccess(this.$t('actionSuccessful', i18n))
                                this.itemToDelete = false
                                this.getCriteria()
                            }
                        ).finally(() => {
                            this.$appService.hideLoading()
                        })
                    }
                }
            )
        },
        backStep () {
            this.$emit('backStep')
        },
        nextStep () {
            this.$emit('nextStep')
        },
        openCriteriaConfig (item) {
            this.$refs.CriteriaConfigEditor.open(this.qcCampaign.id, item.id)
        },
        closeEdit () {
            this.editModel = {}
            this.editModelIndex = -1
        },
        saveEdit (item) {
            if (lodash.isEqual(this.editModel, item)) {
                this.closeEdit()
                return
            }

            if (this.editModelIndex > -1) {
                this.$appService.showLoading()
                QcCampaignService.CriteriaService.replace(this.qcCampaign.id, this.editModel.id, this.editModel).then(() => {
                    this.getCriteria()
                }).catch(this.$appService.hideLoading)
            }

            this.closeEdit()
        },
        handleClickAddNew () {
            this.isShowAddItem = true
            this.$nextTick(() => {
                this.$refs.NewCriteriaName.focus()
            })
        },

        // method for drag and drop
        onCloneCallback (item) {
            return this.$utils.cloneObject(item)
        },
        onMoveCallback (evt) {
            this.dragFrom = evt.draggedContext.element
            this.dragTo = evt.relatedContext.element
            return !this.dragFrom.locked
        },
        onDropCallback () {
            if (this.dragFrom.id === this.dragTo.id) {
                return
            }

            let model = {
                'old_id': this.dragFrom.id,
                'new_id': this.dragTo.id,
            }
            QcCampaignService.swapCriteria(this.qcCampaign.id, model).then(() => {
                this.getCriteria()
            })
        },
        updateCriteria (data) {
            this.$emit('updateCriteria', data)
        },
        changeEnumConfig (data) {
            if (data) {
                this.getCriteria()
            }
        },
    },
}
</script>
<style scoped lang="scss">
.NewQCStep3 {
    font-size: 14px !important;
}

.campaign-info {
    display: block;
    margin: 0 auto;
    width: 100%;
    max-width: 1080px;
}

.campaign-form {
    display: flex;
    flex-direction: column;
    align-items: center;

    .label {
        font-family: "open sans semi", serif;
        margin-bottom: 6px;
        font-size: 13px;
    }
}

.btn-custom-normal {
    height: 40px !important;
    border-radius: 0 !important;
    justify-content: left;
    color: #0052CC;
    font-size: 14px;
    font-family: "open sans bold", serif;
    font-style: normal;
    text-align: center;
}

.btn-back {
    margin-right: 8px;
}

.textarea-custom {
    ::v-deep {
        .v-input__slot {
            background: #FFFFFF;
            border-radius: 0;
            outline: none;
            font-size: 12px;
            margin: 0;
            display: flex;
            align-items: center;
            position: relative;

            &:before, &:after {
                border: none !important;
            }
        }
    }
}

.input-custom {
    ::v-deep {
        .v-input__slot {
            height: 40px;
            background: #FFFFFF;
            border-radius: 0;
            border: none !important;
            outline: none;
            font-size: 14px;
            padding: 0 10px;
            margin: 0;
            display: flex;
            align-items: center;

            &:before, &:after {
                border: none !important;
            }
        }

        .v-label {
            background: #FFFFFF !important;
            padding: 0 6px;

            &:not(.v-label--active) {
                font-size: 14px !important;
                padding-left: 0 !important;
            }
        }
    }
}

.table-add-member {
    border: 1px solid #DADFEC;
    display: flex;
    border-top: none;

    .item-new-member {
        border-right: 1px solid #DADFEC;

        &:last-child {
            border-right: none;
        }

        &:nth-child(1) {
            width: 120px;
        }

        &:nth-child(2) {
            width: 200px;
        }

        &:nth-child(3) {
            flex: 1;
            padding: 0;
        }

        &:nth-child(4), &:nth-child(5), &:nth-child(6), &:nth-child(7) {
            margin: 0 !important;
            align-items: center;
            justify-content: center;
            display: flex;
        }

        &:nth-child(4) {
            width: 200px;
        }

        &:nth-child(5), &:nth-child(6) {
            width: 100px;
        }

        &:nth-child(7) {
            width: 119px;
        }
    }
}

::v-deep {
    .v-input--selection-controls {
        margin-left: 10px !important;
        margin-top: 0 !important;
        padding-top: 0 !important;
        justify-content: center !important;
    }

    .v-text-field {
        padding-top: 0 !important;
        margin-top: 0 !important;
    }

    .v-input__control {
        position: relative;
    }

    .v-text-field__details {
        position: absolute;
        right: 10px !important;
        top: 14px !important;
    }

    .v-select {
        .v-text-field__details {
            right: 40px !important;
        }
    }

    .criteria-table {
        width: 100%;
        font-size: 14px;
        font-family: "open sans", serif !important;
        border: 1px solid #DADFEC;
        border-collapse: collapse;
        border-spacing: 0;

        thead tr:not(.v-datatable__progress) {
            height: 40px !important;
            border-bottom: none;
            padding: 0 !important;

        }

        thead tr th {
            text-transform: capitalize !important;
            color: #12274F !important;
            background: #F4F7FE;
            border-right: 1px solid #DADFEC;
            padding: 0 10px;

            &:last-child {
                border-right: none;
            }

            &:nth-child(1) {
                width: 120px;
            }

            &:nth-child(2) {
                width: 200px;
            }

            &:nth-child(3) {
                flex: 1;
            }

            &:nth-child(4) {
                width: 200px;
            }

            &:nth-child(5), &:nth-child(6) {
                width: 100px;
            }

            &:nth-child(7) {
                width: 120px;
            }

        }

        tbody tr td {
            height: 40px !important;
            border-right: 1px solid #DADFEC;
            padding: 0 10px;
            border-top: 1px solid #DADFEC;

            &:last-child {
                border-right: none;
            }

            &:nth-child(1) {
                width: 120px;
            }

            &:nth-child(2) {
                max-width: 200px;
                padding: 0;
            }

            &:nth-child(3) {
                flex: 1;
                padding: 0;
            }

            &:nth-child(4) {
                width: 200px;
            }

            &:nth-child(5), &:nth-child(6) {
                align-items: center;
                justify-content: center;
                width: 100px;
            }

            &:nth-child(7) {
                width: 120px;
            }
        }
    }
}
</style>
